module.exports = {
      id: "icon-facebook-usage",
      viewBox: "0 0 13.521 25.459",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#icon-facebook",
      toString: function () {
        return this.url;
      }
    }